import { render, staticRenderFns } from "./ClientCreateEdit.vue?vue&type=template&id=2d5c1b1f&scoped=true&"
import script from "./ClientCreateEdit.vue?vue&type=script&lang=js&"
export * from "./ClientCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c1b1f",
  null
  
)

export default component.exports